import { render } from "./Help.vue?vue&type=template&id=7cf99229&scoped=true"
import script from "./Help.vue?vue&type=script&lang=js"
export * from "./Help.vue?vue&type=script&lang=js"

import "./Help.vue?vue&type=style&index=0&id=7cf99229&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7cf99229"

export default script